"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonasCategoriesPanel = void 0;
var react_1 = __importDefault(require("react"));
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var PersonasCategoryCard_1 = require("./PersonasCategoryCard");
/**
 * Left panel listing the persona groups (with empty / no-results
 * fallbacks). Card rendering is delegated to `PersonasCategoryCard`.
 */
exports.PersonasCategoriesPanel = function (_a) {
    var draftSchema = _a.draftSchema, visibleCategories = _a.visibleCategories, hasResults = _a.hasResults, searchText = _a.searchText, searchMatcher = _a.searchMatcher, selectedCategoryId = _a.selectedCategoryId, isCategoryChanged = _a.isCategoryChanged, matchedSignalCountFor = _a.matchedSignalCountFor, onSelectCategory = _a.onSelectCategory;
    var hasCategories = draftSchema.length > 0;
    return (react_1.default.createElement("div", { className: "ws-personas-categories-panel" },
        react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "medium", className: "ws-personas-panel-title" }, "Persona Groups (" + draftSchema.length + ")"),
        !hasCategories ? (react_1.default.createElement("div", { className: "ws-personas-empty-state" }, "No persona groups yet. Use \u201CNew Group\u201D above to create one.")) : !hasResults ? (react_1.default.createElement("div", { className: "ws-personas-empty-state ws-personas-empty-state-search" },
            react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.info }, "No persona groups or personas match \u201C" + searchText.trim() + "\u201D."))) : (visibleCategories.map(function (category) {
            var props = {
                category: category,
                isActive: category.id === selectedCategoryId,
                isChanged: isCategoryChanged(category.id),
                matchedSignalCount: matchedSignalCountFor(category.id),
                searchMatcher: searchMatcher,
                searchText: searchText,
                onSelect: onSelectCategory,
            };
            return react_1.default.createElement(PersonasCategoryCard_1.PersonasCategoryCard, __assign({ key: category.id }, props));
        }))));
};
